// Only run on client side
const longterm = reactive(
  typeof window !== 'undefined'
    ? useStorageDecoder(globalThis.localStorage?.getItem('outspot-longterm') ?? '')
    : {}
)

// Only set up watcher on client side
if (typeof window !== 'undefined') {
  watch(
    longterm,
    () =>
      globalThis.localStorage?.setItem(
        'outspot-longterm',
        useStorageEncoder(longterm),
      ),
    {
      deep: true,
    },
  )
}

export function clearlongterm(): void {
  if (typeof window !== 'undefined') {
    globalThis.localStorage?.setItem('outspot-longterm', useStorageEncoder({}))
  }
}

export default () => longterm
